module.exports = __webpack_public_path__ + "img/SKMA_smoke1.a8960ce9.png";